import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  min-width: 200px;
  max-width: 280px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
`

const Image = styled.img`
  width: 100%;
  height: 80px;
  object-fit: cover;
`

const NoImage = styled.div`
  width: 100%;
  height: 80px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 11px;
`

const Content = styled.div`
  padding: 10px 12px;
`

const Price = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #0294df;
  margin-bottom: 6px;
`

const Details = styled.div`
  font-size: 12px;
  color: #6b6b6b;
  line-height: 1.4;
  margin-bottom: 6px;
`

const DetailLine = styled.div`
  margin-bottom: 2px;
`

const Tags = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 6px;
`

const Tag = styled.span<{ $bg: string; $color: string }>`
  display: inline-block;
  padding: 2px 6px;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
`

const formatPrice = (price: number | string | null): string => {
  if (!price) return ''
  const numPrice = typeof price === 'string' ? parseFloat(price) : price
  if (isNaN(numPrice)) return ''
  return new Intl.NumberFormat('en-CH', {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numPrice)
}

interface ListingMapTooltipProps {
  properties: Record<string, any>
}

export const ListingMapTooltip: React.FC<ListingMapTooltipProps> = ({ properties }) => {
  const imageUrl = properties?.urls_image || null

  return (
    <Container>
      {imageUrl ? <Image src={imageUrl} alt="Listing" /> : <NoImage>No image</NoImage>}
      <Content>
        <Price>{properties?.price ? formatPrice(properties.price) : 'Price on request'}</Price>
        <Details>
          {properties?.rooms_nb && properties?.area && (
            <DetailLine>
              {properties.rooms_nb} rooms &bull; {properties.area} m&sup2;
            </DetailLine>
          )}
          {!properties?.rooms_nb && properties?.area && (
            <DetailLine>{properties.area} m&sup2;</DetailLine>
          )}
          {properties?.rooms_nb && !properties?.area && (
            <DetailLine>{properties.rooms_nb} rooms</DetailLine>
          )}
          {properties?.city_name && <DetailLine>{properties.city_name}</DetailLine>}
          {properties?.address && <DetailLine>{properties.address}</DetailLine>}
        </Details>
        <Tags>
          {properties?.property_type && (
            <Tag $bg="rgba(2, 148, 223, 0.1)" $color="#0294df">
              {properties.property_type}
            </Tag>
          )}
          {properties?.deal_type && (
            <Tag $bg="rgba(0, 179, 65, 0.1)" $color="#00b341">
              {properties.deal_type === 'rent' ? 'For Rent' : 'For Sale'}
            </Tag>
          )}
        </Tags>
      </Content>
    </Container>
  )
}
